import loadable from '@loadable/component';
import { Availability, useFeatureFlag } from '@moda/portal-stanchions';
import React from 'react';
import { ProductDetailsFragment, SizeInventoryFragment } from '../../../../generated/types';
import { useIsApplePaySupported } from '../../../ApplePay';
import { LazyLoad } from '../../../LazyLoad';
import { ApplePayQuickBuy } from '../ApplePayQuickBuy';

import './ProductDetailsFavoriteSectionMobile.scss';

interface Props {
  variant: ProductDetailsFragment;
  size: SizeInventoryFragment | null;
}

const FavoriteIcon = loadable(() => import('../../../../components/Favorite'), {
  resolveComponent: exports => exports.FavoriteIcon
});

const FavoriteButton = loadable(() => import('../../../../components/Favorite'), {
  resolveComponent: exports => exports.FavoriteButton
});

export const ProductDetailsFavoriteSectionMobile: React.FC<Props> = ({ variant, size }) => {
  const isApplePaySupported = useIsApplePaySupported();

  const isAvailableForApplePay =
    variant.availability.toString() === Availability.AvailableNow.toString();

  const applePayQuickBuyEnabled = useFeatureFlag('apple-pay-quick-buy', [
    { default: false },
    { if: true, then: true }
  ]);

  if (isApplePaySupported && isAvailableForApplePay && applePayQuickBuyEnabled) {
    return (
      <div className="ProductDetailsFavoriteSectionMobile">
        <ApplePayQuickBuy variant={variant} size={size} />

        <LazyLoad>
          <FavoriteIcon
            className="ProductDetailsFavoriteSectionMobile__fav-icon"
            variant={variant}
          />
        </LazyLoad>
      </div>
    );
  }

  return (
    <LazyLoad>
      <FavoriteButton
        className="ProductDetailsFavoriteSectionMobile__fav-button"
        variant={variant}
      />
    </LazyLoad>
  );
};
